import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _EditDistance;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import { jsx } from '@instructure/emotion';
import { Checkbox } from '@instructure/ui-checkbox';
import NumberInput from '@instructure/quiz-number-input';
import { toErrors } from '../../../../../../util/instUIMessages';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import t from '@instructure/quiz-i18n/es/format-message';
import { withStyleOverrides } from '@instructure/quiz-common';
var EditDistance = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_EditDistance = /*#__PURE__*/function (_Component) {
  function EditDistance() {
    var _this;
    _classCallCheck(this, EditDistance);
    _this = _callSuper(this, EditDistance, arguments);
    _defineProperty(_this, "handleIgnoreCaseChecked", function () {
      _this.updateScoringData({
        ignoreCase: !_this.props.scoringDataForBlank.ignoreCase
      });
    });
    _defineProperty(_this, "handleDistanceChange", function (event, value, normalizedValue) {
      _this.setState({
        editDistance: value,
        normalizedEditDistance: normalizedValue
      });
    });
    _defineProperty(_this, "handleDistanceBlur", function () {
      var distance = parseInt(_this.state.normalizedEditDistance, 10);
      if (!distance && distance !== 0) {
        distance = 0;
      }
      _this.updateScoringData({
        editDistance: distance
      });
      _this.setState({
        editDistance: distance ? "".concat(distance) : '0'
      });
    });
    var editDistance = _this.props.scoringDataForBlank.editDistance;
    _this.state = {
      editDistance: editDistance,
      normalizedEditDistance: editDistance
    };
    return _this;
  }
  _inherits(EditDistance, _Component);
  return _createClass(EditDistance, [{
    key: "updateScoringData",
    value: function updateScoringData(mods) {
      this.props.updateScoringDataForBlank({
        scoringData: Object.assign({}, this.props.scoringDataForBlank, mods)
      });
    }
  }, {
    key: "render",
    value:
    // ===========
    //  RENDER
    // ===========

    function render() {
      var currentDistance = this.state.editDistance;
      return jsx("div", {
        css: this.props.styles.optionsInput
      }, jsx(NumberInput, {
        min: "0",
        step: "1",
        messages: toErrors(this.props.errors),
        value: currentDistance,
        renderLabel: t('Levenshtein Distance:'),
        onChange: this.handleDistanceChange,
        onBlur: this.handleDistanceBlur,
        "aria-valuemin": 0,
        "aria-valuetext": "".concat(currentDistance, " ").concat(t('Levenshtein Distance'))
      }), jsx("div", {
        css: this.props.styles.optionsInputCheckbox
      }, jsx(Checkbox, {
        value: "ignoreCase",
        label: t('Spelling Only (Ignore Case)'),
        checked: this.props.scoringDataForBlank.ignoreCase || false,
        onChange: this.handleIgnoreCaseChecked
      })));
    }
  }]);
}(Component), _defineProperty(_EditDistance, "displayName", 'EditDistance'), _defineProperty(_EditDistance, "componentId", "Quizzes".concat(_EditDistance.displayName)), _defineProperty(_EditDistance, "propTypes", {
  errors: PropTypes.array,
  scoringDataForBlank: PropTypes.shape({
    ignoreCase: PropTypes.bool,
    editDistance: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  updateScoringDataForBlank: PropTypes.func,
  styles: PropTypes.object
}), _defineProperty(_EditDistance, "defaultProps", {
  errors: void 0,
  scoringDataForBlank: {},
  updateScoringDataForBlank: void 0
}), _EditDistance)) || _class);
export { EditDistance as default };